export enum OnboardingStatusEnum {
    NEW = 'new',
    IN_PROGRESS = 'in-progress',
    FAILED = 'failed',
    COMPLETED = 'completed'
}
